module.exports = function() {
  return new Worker(__webpack_public_path__ + "79ad29e39c16e9068250.worker.js");
};